import React from 'react'
import {
  PROJECT_CONFIGURATION_BULK_FORM_FIELD_KEYS,
  PROJECT_CONFIGURATION_BULK_SELECT_FIELD_SPECS,
  ProjectConfigurationBulkEditFormFields,
  buildProjectConfigurationBulkPatch,
} from 'resources/projectConfigurations/bulkEdit/projectConfigurationBulkEdit'
import { defineBulkEditResource } from './helpers'
import type { BulkEditResourceDefinition } from './types'

const ProjectConfigurationBulkEditFormFieldsBound: React.FC<{
  disabled?: boolean
  visibleFieldKeys?: string[] | null
}> = (props) =>
  React.createElement(ProjectConfigurationBulkEditFormFields, {
    fieldSpecs: PROJECT_CONFIGURATION_BULK_SELECT_FIELD_SPECS,
    ...props,
  })

const projectConfigurationBulkEditDefinition = defineBulkEditResource({
  permissionKey: 'setbacks_and_design_settings',
  allowedBulkFormFieldKeys: [...PROJECT_CONFIGURATION_BULK_FORM_FIELD_KEYS],
  bulkEditToolbarListDefaults: {
    sort: { field: 'title', order: 'ASC' },
  },
  FormFields: ProjectConfigurationBulkEditFormFieldsBound,
  buildPatch: buildProjectConfigurationBulkPatch,
})

export type BulkEditRegistryEntry = {
  resource: string
  definition: BulkEditResourceDefinition
}

export const BULK_EDIT_REGISTRY: BulkEditRegistryEntry[] = [
  {
    resource: 'project_configurations',
    definition: projectConfigurationBulkEditDefinition,
  },
]

export function getBulkEditDefinition(resource: string): BulkEditResourceDefinition | undefined {
  return BULK_EDIT_REGISTRY.find((e) => e.resource === resource)?.definition
}

export function hasListBulkEditSupport(resource: string): boolean {
  return getBulkEditDefinition(resource) !== undefined
}
